// Generated by CoffeeScript 2.7.0
var ImageField;

export default ImageField = Vue.extend({
  props: {
    url: {
      type: String
    },
    helperText: {
      type: String
    },
    title: {
      type: String
    },
    attr: {
      type: String
    },
    hasDelete: {
      type: Boolean
    }
  },
  data: function() {
    return {
      imgUrl: this.url,
      loading: false,
      reload: false
    };
  },
  template: `<div class="form-field image-field">
  <div class="form-field-head mb-3">
    <div class="form-field-title">
      <span>{{ title }}</span>
      <span class="helper-text">{{ helperText }}</span>
    </div>
  </div>
  <div class="form-field-input-container">
    <div class="attachments">
      <div class="attachment-item">
        <label class="add-file-btn">
            <div class="content-centered" v-show="!imgUrl && !loading">
              <input  hidden="true"
                      type="file"
                      accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                      @change="imageChanged"
                      @click="inputClicked">
              <i class="slp-plus"></i>
            </div>
            <div class="content-centered gray-bg" v-if="loading">
              <i class="slp-loading spin"></i>
            </div>
            <div class="content-centered" v-if="reload">
              <div class="error-content error-text">
                <div class="reload-btn">
                  <i class="slp-refresh-circle"></i>
                </div>
                <span>上传失败</span>
              </div>
            </div>
            <div class="image-wrapper" v-show="imgUrl && !loading">
              <img :src="imgUrl" @load="imageLoad"/>
            </div>
            <div class="attancement-content" v-if="imgUrl && !loading && hasDelete">
              <div class="btn icon-btn floated btn-danger btn-small attachment-action delete"
                    @click.stop="removeFile">
                <i class="slp-times"></i>
              </div>
            </div>
        </label>
      </div>
    </div>
    <div class="message"></div>
  </div>
</div>`,
  methods: {
    imageChanged: function(event) {
      var image;
      this.loading = true;
      this.imgUrl = false;
      image = new Skylark.Libs.Storage.Image(event.target.files[0]);
      return image.upload({
        success: (data, xhr) => {
          this.imgUrl = Skylark.Libs.Storage.publicImageUrl(data);
          return this.$emit('imageChanged', this.attr, this.imgUrl);
        },
        error: function(message, xhr) {
          this.loading = false;
          this.reload = true;
          return newAlertify(message.message, {
            type: 'error'
          });
        }
      });
    },
    imageLoad: function() {
      return this.loading = false;
    },
    inputClicked: function() {
      if (this.imgUrl && !this.loading && this.hasDelete) {
        return event.preventDefault();
      }
    },
    removeFile: _.debounce(function() {
      this.imgUrl = '';
      this.loading = false;
      this.reload = false;
      return this.$emit('imageChanged', this.attr, this.imgUrl);
    }, 0)
  }
});
